import { render, staticRenderFns } from "./promotionGraphics.vue?vue&type=template&id=4c23fa29&scoped=true"
import script from "./promotionGraphics.vue?vue&type=script&lang=js"
export * from "./promotionGraphics.vue?vue&type=script&lang=js"
import style0 from "./promotionGraphics.vue?vue&type=style&index=0&id=4c23fa29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c23fa29",
  null
  
)

export default component.exports